import httpService from '@/modules/common/services/httpService';

const baseRoute = '/v2/reports';

const fetchReportFields = async (reportType) => httpService
  .get(`${baseRoute}/get_fields`, { report_type: reportType })
  .then((res) => res.data);

const createReport = async (payload) => httpService.post(baseRoute, payload)
  .then((res) => res.data);

const fetchReport = async (reportId) => httpService
  .get(`${baseRoute}/download`, { report_id: reportId })
  .then((res) => res.data);

export default {
  fetchReportFields,
  createReport,
  fetchReport,
};
